import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  customerCountByBranches: [],
  customerCountByRounds: [],
  papersByRounds: [],
  papersByRoundId: [],
  totalCount: [],
  branchRounds: [],
  roundPapers: [],
  loading: false,
  roundPapersLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    //load dashboard customer-count by branch
    loadCustomerCountByBranchesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCustomerCountByBranchesSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.customerCountByBranches = action?.payload?.result;
    },
    loadCustomerCountByBranchesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //load dashboard customer-count by rounds
    loadCustomerCountByRoundsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCustomerCountByRoundsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.customerCountByRounds = action?.payload?.result;
    },
    loadCustomerCountByRoundsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //load dashboard papers by rounds
    loadPapersByRoundsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadPapersByRoundsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.papersByRounds = action?.payload?.result;
    },
    loadPapersByRoundsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    //load dashboard papers by round id
    loadPapersByRoundIdRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadPapersByRoundIdSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.papersByRoundId = action?.payload?.result;
    },
    loadPapersByRoundIdFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    //load dashboard total customers
    loadTotalCountRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadTotalCountSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.totalCount = action?.payload?.result;
    },
    loadTotalCountFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadBranchRoundsRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadBranchRoundsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.branchRounds = action?.payload?.result;
    },
    loadBranchRoundsFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadRoundPapersRequested(state, action: PayloadAction<any>) {
      state.roundPapersLoading = true;
      state.error = null;
    },
    loadRoundPapersSuccess(state, action: any) {
      state.roundPapersLoading = false;
      state.error = null;
      state.roundPapers = action?.payload?.result;
    },
    loadRoundPapersFail(state, action: PayloadAction<any>) {
      state.roundPapersLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadCustomerCountByBranchesFail,
  loadCustomerCountByBranchesRequested,
  loadCustomerCountByBranchesSuccess,
  loadCustomerCountByRoundsFail,
  loadCustomerCountByRoundsRequested,
  loadCustomerCountByRoundsSuccess,
  loadPapersByRoundsFail,
  loadPapersByRoundsRequested,
  loadPapersByRoundsSuccess,
  loadPapersByRoundIdRequested,
  loadPapersByRoundIdFail,
  loadPapersByRoundIdSuccess,
  loadTotalCountRequested,
  loadTotalCountSuccess,
  loadTotalCountFail,
  loadBranchRoundsRequested,
  loadBranchRoundsSuccess,
  loadBranchRoundsFail,
  loadRoundPapersRequested,
  loadRoundPapersSuccess,
  loadRoundPapersFail,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
